import { InjectionToken } from '@angular/core';

export interface OnTranslateValidationMessages {
  onTranslateValidationMessages(validatorName: string, validatorValue?: any): string;
}

export const TRANSLATE_VALIDATION_MESSAGES = new InjectionToken<OnTranslateValidationMessages>(
  'TRANSLATE_VALIDATION_MESSAGES',
);
